<template>
    <v-bottom-sheet v-model="$store.state.bookingSelectEmployeDialogStatus" hide-overlay elevation="0">
      <v-card color="surface" rounded="t-xl">
        <v-card-text class="px-1 pt-0">
          <v-row justify="center">
            <v-col cols="12" md="9" lg="6">
              <v-card variant="text">
                <v-card-actions>
                  <h3>{{ $t('select_employe') }}</h3>
                  <v-spacer></v-spacer>
                  <v-btn icon @click="$store.commit('setBookingSelectEmployeDialogStatus', false)">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-card-actions>
                <v-divider></v-divider>
                <v-card-text class="px-1">
                  <v-row
                    v-if="!!$store.state.service && !!$store.state.serviceEmployees && $store.state.serviceEmployees.length > 0">
                    <v-col cols="12" md="6"
                      v-for="(employe, index) in $store.state.serviceEmployees"
                      :key="index">
                      <v-card class="pa-2" color="surface" elevation="3" rounded="lg">
                        <div class="d-flex flex-column text-center">
                          <div class="d-flex align-center justify-space-between text-center">
                            <div class="d-flex align-center">
                              <v-avatar class="mr-4">
                                <v-img :src="$store.state.fileBaseUrl+employe.image" cover />
                              </v-avatar>
                              <h4 class="mr-4">{{ employe.title }}</h4>
                            </div>
                          </div>
                          <p v-if="!!employe.description" class="text-red text-justify mb-2" v-html="employe.description.replaceAll('\n','<br/>')"></p>
                          <v-select v-model="item_variable[employe.id]" v-if="!!employe.options && !!employe.options.varibles && employe.options.varibles.length > 0"
                              hide-details
                              density="compact"
                              :items="employe.options.varibles"
                              item-title="name"
                              return-object
                              :label="$t('select_variable')"
                              />
                          <v-btn  elevation="5" color="primary" rounded="lg" class="mt-4"
                            :disabled="!!employe.options && !!employe.options.varibles && employe.options.varibles.length > 0 && !item_variable[employe.id]"
                            @click="$store.commit('setEmploye', Object.assign({}, employe, { variable: item_variable[employe.id] })); $store.commit('setBookingDialogStatus', true); $store.commit('setBookingSelectEmployeDialogStatus', false);">
                            {{ $t('select_and_continue') }}
                          </v-btn>
                        </div>
                      </v-card>
                    </v-col>
                  </v-row>
                  <v-alert v-else type="warning" elevation="3">
                    {{ $t('no_employes_available') }}
                  </v-alert>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-bottom-sheet>
  </template>
  
  <script>
  export default {
    name: "SubmitBookingPage",
    data() {
      return {
        item_variable: {},
      }
    }
  }
  </script>
  
  <style>
  .v-slide-group__next,
  .v-slide-group__prev {
    min-width: 30px !important;
  }
  </style>
  